import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';
import { useCreateContractMutation } from '../Service/contractsApi'; // lub extendedContractsApi

interface ContractGenerateButtonProps {
  reservationId: number;
  templateId?: number;
  onSuccess?: () => void;
}

const ContractGenerateButton = ({
  reservationId,
  templateId,
  onSuccess,
}: ContractGenerateButtonProps) => {
  const [createContract, { isLoading }] = useCreateContractMutation();

  const handleGenerate = async () => {
    try {
      if (typeof templateId !== 'number') {
        throw new Error('templateId is required and must be a number');
      }
      await createContract({
        reservationId,
        templateId,
        content: '',
        id: 0,
      }).unwrap();
      if (onSuccess) onSuccess();
    } catch (error) {
      console.error('Błąd generowania umowy:', error);
    }
  };

  return (
    <Button
      startIcon={<DescriptionIcon />}
      onClick={handleGenerate}
      disabled={isLoading}
      variant="contained"
      color="primary"
    >
      {isLoading ? <CircularProgress size={20} color="inherit" /> : 'Wygeneruj / Regeneruj umowę'}
    </Button>
  );
};

export default ContractGenerateButton;
